<div>
    <div class="pb-lg-2">
        <div [innerHTML]="pageContent" class="ql-editor" style="overflow-wrap: anywhere;overflow-x: hidden;"></div>
    </div>
</div>
